(function() {
    'use strict';

    angular
        .module('app.deducibles')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/deducibles',
                config: {
                    templateUrl: 'app/deducibles/deducibles.html',
                    controller: 'Deducibles',
                    controllerAs: 'vm',
                    title: 'Deducibles'
                }
            },
            {
                url: '/editar-deducible/:id?',
                config: {
                    templateUrl: 'app/deducibles/editarDeducible.html',
                    controller: 'EditarDeducible',
                    controllerAs: 'vm',
                    title: 'EditarDeducible'
                }
            },
            {
                url: '/otros-deducibles',
                config: {
                    templateUrl: 'app/deducibles/otrosDeducibles.html',
                    controller: 'OtrosDeducibles',
                    controllerAs: 'vm',
                    title: 'OtrosDeducibles'
                }
            },
            {
                url: '/editar-otro-deducible/:id?',
                config: {
                    templateUrl: 'app/deducibles/editarOtroDeducible.html',
                    controller: 'EditarOtroDeducible',
                    controllerAs: 'vm',
                    title: 'EditarOtroDeducible'
                }
            }
        ];
    }
})();
